import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ProfileService } from "../services/profile.service";
import { environment } from "../../environments/environment";
import { ToastService } from "../components/toast/toast.service";

@Component({
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  providers: [ProfileService],
})
export class HomeComponent {
  constructor(
    private router: Router,
    private profileService: ProfileService,
    private toastService: ToastService
  ) {
    const webVersion = environment["swVersion"];

    profileService.getVersion().then((serverVersion) => {
      // strip both version of all leading alphabetic characters
      const serverVersionClean = serverVersion.replace(/^\D+/g, "");
      const webVersionClean = webVersion.replace(/^\D+/g, "");

      if (serverVersionClean !== webVersionClean) {
        this.toastService.throwToast(
          "API Version Mismatch! Functionality may be limited. Please refresh the page."
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts